import * as __SNOWPACK_ENV__ from '../../_snowpack/env.js';
import.meta.env = __SNOWPACK_ENV__;

import React, {useEffect, useState} from "../../_snowpack/pkg/react.js";
import ReactDOM from "../../_snowpack/pkg/react-dom.js";
import Goals from "./components/Goals.js";
import Steps from "./components/Steps.js";
const Wizard = ({lang = "en"}) => {
  const [selectedStep, setSelectedStep] = useState(null);
  const [steps, setSteps] = useState([]);
  useEffect(() => {
    import(`./data/goals_${lang}.js`).then(({default: data}) => setSteps(data));
  }, []);
  if (selectedStep == null) {
    return /* @__PURE__ */ React.createElement(Steps, {
      steps,
      lang,
      onSelection: setSelectedStep
    });
  }
  return /* @__PURE__ */ React.createElement(Goals, {
    step: selectedStep,
    lang
  });
};
const domContainer = document.querySelector("#ferpection-wizard");
ReactDOM.render(/* @__PURE__ */ React.createElement(Wizard, {
  lang: domContainer.dataset.lang
}), domContainer);
if (undefined /* [snowpack] import.meta.hot */ ) {
  undefined /* [snowpack] import.meta.hot */ .accept();
}
